export enum Steps {
  STEP_TEMPLATES = 0,
  STEP_CHOOSER = 1,
  STEP_RECIPIENTS = 2,
  STEP_DEPARTMENTS = 3,
  STEP_EMPLOYEES = 4,
  STEP_CONFIRM = 5,
}
